export const FETCH_DEVICE_ACT_INFO = "[COMMON] FETCH_DEVICE_ACT_INFO";
export const FETCH_DEVICE_ACT_INFO_SUCCESS =
  "[COMMON] FETCH_DEVICE_ACT_INFO_SUCCESS";
export const FETCH_DEVICE_ACT_INFO_ERROR =
  "[COMMON] FETCH_DEVICE_ACT_INFO_ERROR";

export const ACTIVATE_DEVICE = "[COMMON] ACTIVATE_DEVICE";
export const ACTIVATE_DEVICE_SUCCESS = "[COMMON] ACTIVATE_DEVICE_SUCCESS";
export const ACTIVATE_DEVICE_ERROR = "[COMMON] ACTIVATE_DEVICE_ERROR";

export const fetchDeviceActInfo = () => {
  return {
    type: FETCH_DEVICE_ACT_INFO,
  };
};

export const activateDevice = (payload) => {
  return {
    type: ACTIVATE_DEVICE,
    payload: payload,
  };
};
